import { Col, Row } from "antd";
import { DataTableSearch } from "common/components/dataTableLayout/dataTableSeach";
import { ButtonGroup } from "common/components/buttonGroup/buttonGroup";
import styles from "features/dashboard/sections/candidates/filters/filters.module.scss";

export const PipelineCandidateFilters = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
  statusCounts = [],
  disabled = true,
}) => {
  return (
    <Row gutter={[8, 8]} className={styles.pipelineCandidateFilters}>
      <Col className={styles.pipelineCandidateFilters__searchCol}>
        <DataTableSearch
          defaultValue={search}
          onChange={(e) => onSearchChange(e.target.value || null)}
        />
      </Col>
      {statusCounts.length > 0 && (
        <Col flex="auto">
          <ButtonGroup
            value={status}
            onChange={onStatusChange}
            disabled={disabled}
            divided
          >
            <ButtonGroup.Button value={null}>All</ButtonGroup.Button>
            {statusCounts.map(({ statusId, status: statusName, count }) => (
              <ButtonGroup.Button key={statusId} value={statusId}>
                {statusName}
                <span className={styles.pipelineCandidateFilters__count}>
                  {count}
                </span>
              </ButtonGroup.Button>
            ))}
          </ButtonGroup>
        </Col>
      )}
    </Row>
  );
};
